export const TiposEnum = [
    { id: "mensal", label: "Mensal" },
    { id: "anual", label: "Anual" },
    { id: "trimestral", label: "Trimestral" },

];

export const SetoresEnum = [
    { id: "contabilidade", label: "Contabilidade" },
    { id: "legalizacao e onboarding", label: "Lergalização & Onborging" },
    { id: "cs", label: "CS" },
];

export const ContabilidadeSubSetoresEnum = [
    { id: "contabilidade", label: "Contabilidade" },
    { id: "fiscal", label: "Fiscal" },
    { id: "departamento_pessoal", label: "Departamento Pessoal" },
];


export const LegalizacaoSubSetoresEnum = [
    { id: "alvaras e taxas", label: "Alvarás e taxas" },
];

export const CsSubSetoresEnum = [
    { id: "credenciamento", label: "Credenciamento" },
];


